module.exports = __webpack_public_path__ + "static/img/ganke.ca5ebdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ganke.png
// module id = 5n+j
// module chunks = 1